module.exports = __webpack_public_path__ + "img/reload.ebc54e28.svg";